export class BaseFilterModel {

  public search: string;
  typeCryptoBuy?: number;
  beginDateStr?: string;
  endDateStr?: string;
}